import * as THREE from 'three'
import { OrbitControls } from 'three/addons/controls/OrbitControls.js'

export default function createCamera({ sizes, canvas })
{
  const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
  camera.position.set(3, 13, -25)


  const controls = new OrbitControls(camera, canvas)
  controls.enableDamping = true

  controls.target.set(-6, 0, 0)
  controls.update()

  const resize = () =>
  {
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()
  }

  const update = () =>
  {
    controls.update()
  }

  return { camera, controls, resize, update }
}
